import {
  FLUSH_COMMON_OBJECT,
  FLUSH_MENU_TREE,
  GET_CURRENT_MENU_TREE,
  HIDE_ALERT,
  HIDE_LOADER,
  INITIATE_COMMON,
  NAVURL,
  SET_MENU_TREE,
  SHOW_ALERT,
  SHOW_LOADER,
  SET_ORGANIZATIONS,
  SET_USER_TYPE
} from './commonActionTypes'

export default function common(state = [], action) {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_LOADER:
      return {
        ...state,
        loading: false
      }
    case SHOW_ALERT:
      return {
        ...state,
        alert: action.text,
        status: action.status
      }
    case HIDE_ALERT:
      return {
        ...state,
        alert: null,
        status: null
      }
    case GET_CURRENT_MENU_TREE:
      return state.menuTree ? state.menuTree : []
    case FLUSH_COMMON_OBJECT:
      return {
        url: '',
        alert: null,
        status: null,
        menuTree: []
      }
    case FLUSH_MENU_TREE:
      return {
        ...state,
        menuTree: []
      }
    case NAVURL:
      console.log(action, "action")

      return {
        ...state,
        url: action.url,
        pagename: action.pagename
      }
    case SET_MENU_TREE:
      return {
        ...state,
        menuTree: action.menuTree
      }
    case INITIATE_COMMON:
      return action.data
    case SET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.organizations
      }
    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.userType
      }
    default:
      return state
  }
}
